<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_no') ||
                '产品规格编号'
            "
          >
            <el-input v-model="formData.orderGoodsSpecNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_identify_spec_no') ||
                '产品规格识别编号'
            "
          >
            <el-input v-model="formData.identifyGoodsSpecNo" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_name') ||
                '产品规格名称'
            "
          >
            <el-input v-model="formData.orderGoodsSpecName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_englishSize') ||
                '英文尺寸'
            "
          >
            <el-input v-model="formData.v_englishSize" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec') || '产品规格'
            "
          >
            <el-input v-model="formData.spec" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_unit') ||
                '规格单位'
            "
          >
            <el-input v-model="formData.v_specUnit" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_inGroupQty') ||
                '规格数量'
            "
          >
            <el-input v-model="formData.inGroupQty" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_spec_technologyD') ||
                '工艺要求说明'
            "
          >
            <el-input
              v-model="formData.technologyDesc"
              type="textarea"
              readonly
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: { orderGoodsSpecCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsSpecCode) return
      this.$api
        .pendingOrderGoodsSpecDetailApi({
          orderGoodsSpecCode: this.orderGoodsSpecCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
